import React, { Component } from "react";
//import Hls from "hls.js";
import classes from "./Video.module.css";

export default class HLS extends Component {
  state = { playing: true, hls: true };

  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  isChrome = /^(?!.*Edge).*Chrome/i.test(navigator.userAgent);

  play = () => {
    if (this.video.paused) {
      this.video.play();
      this.setState({ playing: true });
    } else {
      this.video.pause();
      this.setState({ playing: false });
    }
  };

  componentWillReceiveProps(props) {
    if (this.props.playing) {
      this.video.pause();
    } else {
      this.video.play();
    }
    /*
    if (this.props.data !== props.data) {
      if (props.warming) {
        props.soundEffect.src = `https://cdn.fitzet.com/static%2Fsound${props.data}.mp3?alt=media`;
        props.soundEffect.play();
      } else {
        props.soundEffect.src = `https://cdn.fitzet.com/static%2Fsoundchimehigh.mp3?alt=media`;
        props.soundEffect.play();
      }
    }
    */
  }

  render() {
    if (this.props.warming) {
      this.props.soundEffect.src = `https://cdn.fitzet.com/static%2Fsound${this.props.data}.mp3?alt=media`;
      this.props.soundEffect.play();
    } else {
      this.props.soundEffect.src = `https://cdn.fitzet.com/static%2Fsoundchimehigh.mp3?alt=media`;
      this.props.soundEffect.play();
    }
    return (
      <div>
        <video
          /* ref={(video) => {
            this.video = video;
          }}*/
          ref={this.props.setRefVideo}
          className={classes.videoElement}
          muted
          playsInline
          loop
          autoPlay
        >
          <source
            src={`https://cdn.fitzet.com/static%2F${this.props.data}.mp4?alt=media`}
          />
        </video>

        {/*this.props.warming ? (
          <audio autoPlay playsInline>
            <source
              src={`https://cdn.fitzet.com/static%2Fsound${this.props.data}.mp3?alt=media`}
              type="audio/mpeg"
            />
          </audio>
        ) : (
          <audio autoPlay playsInline>
            <source
              src={`https://cdn.fitzet.com/static%2Fsoundchimehigh.mp3?alt=media`}
              type="audio/mpeg"
            />
          </audio>
        )*/}
      </div>
    );
  }
}
